import { Button } from 'components'
import { useSelector } from 'react-redux'
import { STATICS } from 'statics'
import { formatDate } from 'utils'
import './style.scss'

export function ConfirmScheduleSuccess({ onClose }) {
  const {
    pendingConfirmation: {
      expectedInstallationDate,
      expectedInstallationTurn,
      expectedAttendancePeriod,
    },
  } = useSelector(state => state.serviceOrder)

  return (
    <div className='confirm-schedule-success'>
      <div className='icon-container'>
        <STATICS.ROUNDED_CHECK className='icon' />
      </div>
      <div className='content'>
        <p>Sua visita técnica foi confirmada com sucesso!</p>
        <p>Aguarde a visita do técnico na data agendada.</p>
        <p>
          <strong>{formatDate(expectedInstallationDate)}</strong> no período{' '}
          <strong>{expectedInstallationTurn}</strong> ({expectedAttendancePeriod})
        </p>
      </div>
      <div className='actions'>
        <Button onClick={onClose} color='primary'>
          Ok, entendi!
        </Button>
      </div>
    </div>
  )
}
